import { useState, useEffect } from 'react';
import { Card } from './ui/card';
import { AlertCircle, CheckCircle, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';

export function SocialLoginStatus() {
  const [showStatus, setShowStatus] = useState(false);

  useEffect(() => {
    // Only show in development or if user is admin
    const isDev = import.meta.env.DEV;
    const isAdmin = localStorage.getItem('tension_is_admin') === 'true';
    
    setShowStatus(isDev || isAdmin);
  }, []);

  if (!showStatus) {
    return null;
  }

  return (
    <Card className="p-6 bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800">
      <div className="space-y-4">
        <div className="flex items-start gap-3">
          <AlertCircle className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
          <div className="flex-1 space-y-2">
            <h3 className="font-medium text-blue-900 dark:text-blue-100">
              Social Login Configuration
            </h3>
            <p className="text-sm text-blue-700 dark:text-blue-300">
              Google and Apple sign-in are available on the auth page, but require OAuth provider setup in Supabase.
            </p>
          </div>
        </div>

        <div className="space-y-2 pl-8">
          <div className="flex items-start gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-blue-600 dark:bg-blue-400 mt-2 flex-shrink-0" />
            <p className="text-sm text-blue-700 dark:text-blue-300">
              <strong>Google OAuth:</strong> Configure in Supabase Dashboard → Authentication → Providers → Google
            </p>
          </div>
          <div className="flex items-start gap-2">
            <div className="w-1.5 h-1.5 rounded-full bg-blue-600 dark:bg-blue-400 mt-2 flex-shrink-0" />
            <p className="text-sm text-blue-700 dark:text-blue-300">
              <strong>Apple OAuth:</strong> Configure in Supabase Dashboard → Authentication → Providers → Apple
            </p>
          </div>
        </div>

        <div className="flex gap-2 pl-8">
          <Button
            variant="outline"
            size="sm"
            className="text-xs border-blue-300 dark:border-blue-700 hover:bg-blue-100 dark:hover:bg-blue-900/40"
            onClick={() => window.open('https://supabase.com/docs/guides/auth/social-login/auth-google', '_blank')}
          >
            <ExternalLink className="w-3 h-3 mr-1" />
            Google Setup Guide
          </Button>
          <Button
            variant="outline"
            size="sm"
            className="text-xs border-blue-300 dark:border-blue-700 hover:bg-blue-100 dark:hover:bg-blue-900/40"
            onClick={() => window.open('https://supabase.com/docs/guides/auth/social-login/auth-apple', '_blank')}
          >
            <ExternalLink className="w-3 h-3 mr-1" />
            Apple Setup Guide
          </Button>
        </div>

        <div className="p-3 bg-white dark:bg-neutral-800 rounded-lg border border-blue-200 dark:border-blue-800">
          <p className="text-xs text-neutral-600 dark:text-neutral-400">
            💡 <strong>Note:</strong> Social login buttons will show "provider is not enabled" error until OAuth is configured in Supabase. Email/password authentication works without additional setup.
          </p>
        </div>
      </div>
    </Card>
  );
}
